<template>
    <div class="upload-wrapper">
        <div class="uw-title" v-text="title"></div>        
        <div class="upload-operation">
            <div class="no-img" @click='uploadClick' v-show='!isShow'>
                <i class="icon icon-add"></i>
            </div>
            <div class="have-img"  @click='uploadClick' v-show="isShow">
                <i class="icon icon-finish"></i>
                <p class="img-cap">Finished</p>
            </div>
        </div>
        <!-- <div class="img-info">
            <div class="img-info-ele" v-for = "(item, ind) in needShowList" :key="ind">
                <div class="img-info-title" v-text="item.keys"></div>
                <div class="img-info-content" v-text="item.value"></div>
            </div>
        </div>         -->
        <input ref='uploadInstance' type="file" :id="title" @change="change" @cancel="cancel" accept="image/*" style='display:none'>
    </div>
</template>
<script>
import { ref, getCurrentInstance } from 'vue'
//newFace
import ImageCompressor from 'image-compressor.js'
export default {
    props:{
        title:{
            type:String
        }
    },
    setup(props, ctx) {      
        const isShow = ref(false)
        const uploadInstance = ref()
        const proxy  = getCurrentInstance().proxy
        const clicked = ref(false)        
        const setImage = (file) => {
            ctx.emit("modify",file)
        }
        const change = async (e) => {
            if(e.target.files.length == 0) {
                
                // uploadBury('complete', props.needShowList['file_name'] ,1, null)
                return
            }     
            if (e.target.files[0].type.indexOf('image') > -1) {
                let file = e.target.files[0]
                let file_size = file.size / 1024 / 1024
                const file_name = file.name
                if (file_size < 10){                    
                    new ImageCompressor(file, {                    
                        quality: .5,
                        success (new_file) {
                            const size = new_file.size / 1024 / 1024                    
                            const file = new File([new_file], file_name, {type:'Blob'})                        
                            if(size > 10) {
                                proxy.$toast.show('Image size is too big, limit 10MB')
                                return 
                            }
                            setImage(file)
                            isShow.value = true
                        }
                    })
                } else {
                    setImage(file)
                    isShow.value = true
                }         

            }
        }
        const uploadClick = () => {
            clicked.value = true
            uploadInstance.value.click()
            // uploadBury("focus", uploadInstance.value.value,0,null )            
        }
        
        const cancel = () => {
            // uploadBury("complete", props.needShowList['file_name'],1,"cancel")
            // ctx.emit("refreshRequestId")
        }
        return {
            change,
            uploadClick,
            isShow,
            uploadInstance,
            cancel
        }
    }
}
</script>
<style lang="less" scoped>
@import "assets/less/icon.less";
    .upload-wrapper{
        width: 650px;
        margin:0 0 50px 0;
        border-radius: 15px;
        background:#fff;
        padding:25px 0;
        .uw-title{
            font-size: 32px;
            color:#000;
            margin-bottom: 30px;
        }
        .upload-operation{
            .no-img{
                width: 276px;
                height:164px;
                background:#F5F3FF;
                display:flex;
                justify-content: center;
                align-items: center;
                border-radius: 15px;
            }
            .have-img{
                width: 276px;
                height:114px;
                background:#1D1C43;
                padding-top: 50px;                                
                border-radius: 15px;
                .img-cap{
                    color:#fff;
                    text-align: center;
                    margin-top: 10px;
                    font-size: 24px;
                }
            }
        }
        .img-info{
            margin-top: 30px;
            .img-info-ele{
                padding:25px 0;
                border-bottom:2px solid #EFEEF1;
                .img-info-title{
                    color:#73698F;
                    font-size: 26px;
                }
                .img-info-content{
                    color:#000;
                    font-size: 30px;
                    margin-top: 30px;
                }
            }
        }
    }
</style>